import add from "./addSsoUser";

export default {
  add,
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/users/ssoUser/index.js